import React from "react";

import Colors from "./colors"
function fn(text, count, setShow) {
  return text.slice(0, count) + (text.length > count ? "" : "");
}
const ReadMore = ({ text }) => {
  const [show, setShow] = React.useState(false);
  return (
    <>
      {show ? (
        <>
          {text}
          <span
            style={{ color: Colors.buttonTextColor, cursor: "pointer", fontWeight: "bold"}}
            onClick={() => setShow(false)}
          >
            {" "}
            Less
          </span>
        </>
      ) : (
        <>
          {fn(text, 100)}
          {text.length > 100 && (
            <span
              style={{ color: Colors.buttonTextColor, cursor: "pointer", fontWeight: "bold"}}
              onClick={() => setShow(true)}
            >
              {" "}
              Read More
            </span>
          )}
        </>
      )}
    </>
  );
};

export default ReadMore;
